import { Component, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { AppRoutes } from '@gs-2.0/core';

/**
 * Back navigation button rendered at the top of the fund-management pages
 * (Contribute, Grant, Distribution, Transfer, Activity, Currency Conversion and
 * Manage Recurring). Defaults to "Back to Dashboard" pointing at the fund dashboard.
 *
 * Figma: node 596-5182 (desktop) / node 649-2864 (mobile)
 */
@Component({
  selector: 'app-back-button',
  standalone: false,
  templateUrl: './back-button.component.html',
  styleUrls: ['./back-button.component.scss'],
})
export class BackButtonComponent {
  private readonly router = inject(Router);

  /**
   * Translation key for the button label. Defaults to the shared
   * "Back to Dashboard" key used by every fund-management page.
   */
  label = input<string>('fund.back_to_dashboard');

  /**
   * Route the button navigates to. Defaults to the fund dashboard.
   */
  route = input<string>(AppRoutes.FUND_DASHBOARD);

  onClick(): void {
    void this.router.navigateByUrl(this.route());
  }
}
